import { Banner, Button, Stack } from '@customerio/pluma-components/react';

type DeliveryTableErrorProps = { onReload?: () => void };

export function DeliveryTableError({ onReload }: DeliveryTableErrorProps) {
  return (
    <Stack gap="200">
      <Banner variant="critical" title="Delivery logs failed to load" />
      {onReload != null ? (
        <Button variant="secondary" size="sm" icon="rematch" onClick={onReload}>
          Try again
        </Button>
      ) : null}
    </Stack>
  );
}
